export default "__VITE_ASSET__RE53J9uo__"